export default __webpack_public_path__ + "static/media/yuki.0cd02e54.jpeg";